import React from 'react';
import { RouteConfig } from '../types/route.types';
import { RouteObject } from 'react-router-dom';
import { RouteErrorBoundary } from '../routes/AppRoutes';
import type { MenuItem } from '../components/layout/MainMenu';

export const generateRouteChildren = (routes: RouteConfig[]): RouteObject[] => {
  const routeChildren: RouteObject[] = [];

  routes.forEach((route) => {
    if (route.index) {
      routeChildren.push({
        index: true,
        element: route.element,
        errorElement: <RouteErrorBoundary />,
      });
    } else if (route.element) {
      routeChildren.push({
        path: route.path.substring(1), // Remove leading slash
        element: route.element,
        errorElement: <RouteErrorBoundary />,
      });
    }

    if (route.routes) {
      route.routes.forEach((childRoute) => {
        routeChildren.push({
          path: childRoute.path,
          element: childRoute.element,
          errorElement: <RouteErrorBoundary />,
        });
      });
    }

    // Add routes for children menu items
    if (route.children) {
      route.children.forEach((child) => {
        if (child.element) {
          routeChildren.push({
            path: child.path.substring(1),
            element: child.element,
            errorElement: <RouteErrorBoundary />,
          });
        }
        if (child.routes) {
          child.routes.forEach((grandChild) => {
            routeChildren.push({
              path: grandChild.path,
              element: grandChild.element,
              errorElement: <RouteErrorBoundary />,
            });
          });
        }
      });
    }
  });

  return routeChildren;
};

export const getMenuItems = (routes: RouteConfig[], isSysAdmin: boolean = false): MenuItem[] => {
  return routes
    .filter((route) => {
      // Filter out hidden routes
      if (route.hidden) return false;

      // Filter out routes that require sysAdmin if user is not sysAdmin
      if (route.requireSysAdmin && !isSysAdmin) return false;

      return true;
    })
    .map(
      ({ key, label, path, icon, children }): MenuItem => ({
        key,
        label,
        path,
        icon,
        children: children ? getMenuItems(children, isSysAdmin) : undefined,
      })
    );
};
